import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import AddBoxIcon from '@mui/icons-material/AddBox';
import DrMadhuSign from "../../assets/imaging/madhusign.png";
import { allowedUsers } from '../allowedUsers';
import { getPracticeId, patientPhotoUrl } from '../../config/practice';

const VenousModal = ({ ismodal, setIsmodal, data }) => {
  const [formData, setFormData] = useState({
    take: '',
    tape: '',
    examDate: dayjs().format("YYYY-MM-DD"),
    requestedby: "DR. MADHU PAMGANAMAMULA",
    technician: "ART MONTANA",
    history: '',
    swelling: '',
    signoff: "",
    technicianComments: '',
conditions: {
      commonFemoral: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      superficialFemoral: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      popliteal: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      posteriorTibial: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      peroneal: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      greaterSaphenous: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      }
    },
  });
    const[isLoading,setIsLoading]=useState(false)
    const [openToast, setOpenToast] = useState(false);
    const [prevExamData, setPrevExamData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastSeverity, setToastSeverity] = useState("error");
    const practiseid = getPracticeId();
    const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
    const userConfig = useSelector((state) => state.userconfig);

const technicianComments = [
  { id: 1, label: '', options: [ 'NO DEEP VEIN THROMBOSIS'] },
  { id: 2, label: '', options: [ 'ALL VENIE ARE NORMALLY COMPRESSED'] },
  { id: 3, label: '', options: [ 'GOOD AUGMENTATION'] },
  { id: 4, label: '', options: [ 'NO REFLUX'] },
  { id: 5, label: '', vlaue: '' },
  { id: 6, label: '', vlaue: '' }

  // { id: 3, label: 'ALL VELOCITIES ARE NORMAL', options: [ 'ALL VELOCITIES ARE NORMAL'] },
  // { id: 4, label: 'VERTEBRAL, LEFT AND RIGHT, ANTEGRADE NORMAL', options: [ 'VERTEBRAL, LEFT AND RIGHT, ANTEGRADE NORMAL'] },
  // { id: 5, label: 'NO HEMODYNAMICALLY SIGNIFICANT LESIONS', options: [ 'NO HEMODYNAMICALLY SIGNIFICANT LESIONS'] },

];
    const calculateAge = (dob) => {

        const birthDate = dayjs(dob);
        const today = dayjs();
        return today.diff(birthDate, "year");
    };


  const age = calculateAge(data?.dob);

// const handleChange = (e, section, field, value) => {
//   console.log("e", e, "section", section, "field", field, "value", value);
//   const { type, checked } = e.target;
//   const newValue = value || e?.target?.value;

//   if (type === 'checkbox') {
//     // Checkbox logic (unchanged)
//     if (field && field.includes(".")) {
//       const [region, condition, side] = field.split('.');

//       setFormData(prevData => {
//         const updatedData = {
//           ...prevData,
//           [section]: {
//             ...prevData[section],
//             [region]: {
//               ...prevData[section][region],
//               [condition]: {
//                 ...prevData[section][region][condition],
//                 [side]: checked,
//               },
//             },
//           },
//         };
//         return updatedData;
//       });
//     }
//   } else if (section === "technicianComments") {
//     // Handling the change for technician comments
//     setFormData(prevData => {
//       const updatedComments = [...prevData.technicianComments]; // Copy the array
//       updatedComments[field] = {  // Update the specific index (field = index)
//         ...updatedComments[field], // Copy the current comment at this index
//         value: newValue, // Update the value
//       };

//       return {
//         ...prevData,
//         technicianComments: updatedComments, // Update the technicianComments array
//       };
//     });
//   } else {
//     setFormData(prevState => ({
//       ...prevState,
//       [field]: newValue,
//     }));
//   }
// };


const handleChange = (e, section, field, value = null) => {
  const { type, checked } = e?.target ?? {};
  const newValue = value ?? (type === 'checkbox' ? checked : e?.target?.value);

  // Checkbox logic for nested fields (field = "region.condition.side")
  if (type === 'checkbox' && field?.includes('.')) {
    const [region, condition, side] = field.split('.');
    setFormData(prevData => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        [region]: {
          ...prevData[section][region],
          [condition]: {
            ...prevData[section][region][condition],
            [side]: checked,
          },
        },
      },
    }));
  } 

  // Technician Comments (field = index in array)
  else if (section === "technicianComments") {
    setFormData(prevData => {
      const updatedComments = [...prevData.technicianComments];
      updatedComments[field] = {
        ...updatedComments[field],
        value: newValue,
      };
      return { ...prevData, technicianComments: updatedComments };
    });
  } 

  // Normal fields (including simple checkboxes)
  else {
    setFormData(prevState => ({
      ...prevState,
      [field]: newValue,
    }));
  }
};


    const validateForm = () => {
    const errors = [];

    if (!formData.examDate) errors.push("Exam Date is required.");
    // if (!formData.history.trim()) errors.push("Patient History is required.");
    return errors;
  };

  const handleSave = async () => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {
      try {
        setIsLoading(true);
        const payload = {
          patient_id: data?.patientid,
          pat_name: `${data?.firstname} ${data?.lastname}`,
          pat_dob: data?.dob,
          examDate: formData.examDate,
          pat_age: age,
          pat_gender: data?.gender?.toUpperCase(),
          encounterid: data?.appointmentid,
          pathistory: formData.history,
          take: formData.take,
          tape: formData.tape,
          requestedby: formData.requestedby,
          technician: formData.technician,
          swelling: formData.swelling,
          conditions: formData.conditions,
          technicianComments: formData.technicianComments,
          signoff: formData?.signoff || '',
        };

        const user = await api.get('/auth/me');
        const [year, month, day] = formData.examDate.split("-");
        const formattedDate = `${month}/${day}/${year}`;

        const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
          "Worksheet_Type": "VENOUS",
          "createdby": user?.username || '',
          "appurl": window.location.origin,
          "Exam_Date": formattedDate,
          "data": payload
        });

        if (response.status === 200) {
          const pdf = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`, {
            "filename": response?.data?.filename,      
            "worksheet_type":"VENOUS",
            "appurl": window.location.origin,
            "documenttypeid": response?.data?.documenttypeid,
            "exam_date": formattedDate
          });

          setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);

          setTimeout(() => {
            handleClear();
            setIsmodal(false);
          }, 1000);
        } else {
          setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
        }
      } catch (error) {
        console.log(error);
        setToastMessage("Something Went Wrong");
        setToastSeverity("error");
        setOpenToast(true);
      } finally {
        setIsLoading(false);
      }
    }
  };


  const handleUpdate = () => {
    console.log('Updating report...', formData);
    // Update report logic
  };

  const handleClear = () => {
  setFormData({
    take: '',
    tape: '',
    examDate: dayjs().format("YYYY-MM-DD"),
    requestedby: '',
    technician: '',
    history: '',
    swelling: '',
    technicianComments: '',
    conditions: {
      commonFemoral: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      superficialFemoral: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      popliteal: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      posteriorTibial: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      peroneal: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      },
      greaterSaphenous: { 
        spontaneous: { R: false, L: false },
        phasic: { R: false, L: false },
        augmented: { R: false, L: false },
        competent: { R: false, L: false },
        nonPulsatile: { R: false, L: false },
        compression: { R: false, L: false }
      }
    }
  });
};



const fetchdata = async () => {

  try {
   setLoading(true);
    const examtype = "VENOUS";
    const response = await api.get(
      `/v1/${practiseid}/imaging/patient/${data.patientid}/get-previous-exam/${examtype}`
    );

    if (response?.status === 200 && response?.data?.length > 0) {
      console.log("Raw API Response for Previous Exams:", response.data);
      // const raw = response?.data[0] ? [response.data[0]] : [];
      const raw = response?.data?.map((exam) => {
        // Optionally, parse the JSON data inside each exam
        let parsedData = {};
        try {
          parsedData = JSON.parse(exam.data);
        } catch (err) {
          console.error("Failed to parse exam.data", err);
        }

        return {
          ...exam,
          parsedData,
        };
      }) || [];

      console.log("Parsed Previous Exam Data:", raw);
      setPrevExamData(raw);
      setLoading(false);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    setLoading(false);
  }
};

useEffect(() => {
  if (ismodal) {
    fetchdata();
  }
}, [ismodal]);


const handleFillFields = (examData) => {
    if (!examData) return;

    const data = typeof examData === 'string' ? JSON.parse(examData) : examData;

    // Merge conditions
    const mergedConditions = { ...formData.conditions };
    Object.keys(mergedConditions).forEach(region => {
      Object.keys(mergedConditions[region]).forEach(cond => {
        mergedConditions[region][cond] = {
          ...mergedConditions[region][cond],
          ...(data.conditions?.[region]?.[cond] || {})
        };
      });
    });

    const updatedComments = Array.isArray(data.technicianComments)
      ? data.technicianComments.map(c => ({ value: c.value || '' }))
      : Array(6).fill({ value: '' });

    setFormData(prev => ({
      ...prev,
      take: data.take || '',
      tape: data.tape || '',
      examDate: data.examDate || '',
      requestedby: data.requestedby || '',
      technician: data.technician || '',
      history: data.pathistory || '',
      swelling: data.swelling || '',
      signoff: data.signoff || false,
      conditions: mergedConditions,
      technicianComments: updatedComments
    }));
  };


   if (!ismodal) return null;

  return (

        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">VENOUS</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">
            &times;
          </button>
        </div>
        <hr className="mb-4 border-gray-300" />
            {/* Patient Info */}
        <div className="flex items-center space-x-4 mb-4">
          <img

            src={patientPhotoUrl(data.patientid)}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
          <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
  #{data?.patientid}
</div>

            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span> {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold"   >Age:</span> {age} &nbsp;|&nbsp;
              <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>
    




{prevExamData.length > 0 && (
<table className="min-w-full text-sm text-left border border-gray-300">
      
        <thead className="border bg-gray-200">
          <tr>
            <th colSpan="7" className="border px-3 py-2 font-semibold text-[#8B1818] text-center">Previous Exam Data</th>
          </tr>
          <tr>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">ID</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Exam</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Patient ID</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Date of Service</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Created By</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Action</th>
          </tr>
        </thead>
      

      <tbody className="border divide-y divide-gray-200">
        {prevExamData.length > 0 ? (
          prevExamData.map((exam) => (
            <tr key={exam.id} className="border hover:bg-gray-50">
              <td className="border px-3 py-2">{exam.id}</td>
              <td className="border px-3 py-2">{exam.exam}</td>
              <td className="border px-3 py-2">{exam.patientid}</td>
              <td className="border px-3 py-2">{exam.dateofservice ? dayjs(exam.dateofservice).format("MM-DD-YYYY") : ""}</td>
              <td className="border px-3 py-2">{exam.createdby}</td>
              <td className="border px-3 py-2">
                  <AddBoxIcon onClick={() => handleFillFields(exam.data)} className="cursor-pointer text-gray-700 hover:text-gray-900" />
              </td>
            </tr>
          ))
        ) : (
          <tr>
              <td colSpan="7" className="border px-3 py-2 text-center text-gray-500">
                {loading ? "Getting Records ..." : " No records found"}
              </td>
          </tr>
        )}
      </tbody>
    </table>
)}



    <div className="p-8">
      {/* Input Fields */}
      <div className="grid grid-cols-4 gap-6 mb-8">
        <div>
          <label className="block text-sm font-medium text-gray-700">CHART #</label>
          <input type="text" value={data?.patientid} readOnly className="border rounded px-2 py-1 w-full" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">TAKE #</label>
          <input
            type="text"
            value={formData.take}
            onChange={(e) => handleChange(e, 'formData', 'take', e.target.value)}
            className="border rounded px-2 py-1 w-full"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">TAPE</label>
          <input
            type="text"
            value={formData.tape}
            onChange={(e) => handleChange(e, 'formData', 'tape', e.target.value)}
            className="border rounded px-2 py-1 w-full"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">DATE (mm/dd/yyyy)</label>
          <input type="date" value={formData.examDate} 
          onChange={(e) => handleChange(e, 'formData', 'examDate', e.target.value)}
          className="w-full border rounded px-2 py-1" />
        </div>
        </div>
        <div className="grid grid-cols-2 gap-6 mb-8">
        <div>
          <label className="block text-sm font-medium text-gray-700">REQUESTED BY</label>
          <input
            type="text"
            className="w-full border rounded px-3 py-2 mt-1"
            value={formData.requestedby}
            onChange={(e) => handleChange(e, 'formData', 'requestedby', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">TECHNICIAN</label>
          <input
            type="text"
            className="w-full border rounded px-3 py-2 mt-1"
            value={formData.technician}
            onChange={(e) => handleChange(e, 'formData', 'technician', e.target.value)}
          />
        </div>
      </div>

      {/* History */}
        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea
            placeholder="Enter Patient History here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.history}
            onChange={(e) => handleChange(e, 'formData', 'history', e.target.value)}
          />
        </div>

      {/* Swelling */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700">SWELLING</label>
        <textarea
          className="w-full border rounded px-3 py-2 mt-1"
          placeholder="Enter here..."
          value={formData.swelling}
          onChange={(e) => handleChange(e, 'formData', 'swelling', e.target.value)}
        />
      </div>


{/* Table with Checkboxes */}
<div className="mb-8">
  <table className="table-auto w-full border-separate border-spacing-0 border border-gray-300">
  <thead>
    <tr className="bg-blue-100">
      <th className="px-2 py-1 text-sm bg-blue-100"></th> {/* Empty header for alignment */}
        <th key="Common Femoral" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Common Femoral
        </th>
        <th key="Superficial Femoral" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Superficial Femoral
        </th>
        <th key="Popliteal" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Popliteal
        </th>
        <th key="Posterior Tibial" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Posterior Tibial
        </th>
        <th key="Peroneal" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Peroneal
        </th>
        <th key="GreaterSaphenous" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Greater Saphenous
        </th>
    </tr>
    <tr className="bg-blue-200">
      <th className="px-2 py-1 text-sm bg-blue-100"></th> {/* Empty header for alignment */}
          <th key="CommonFemoralR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="CommonFemoralL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="Superficial FemoralR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="Superficial FemoralL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="PoplitealR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="PoplitealL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="Posterior TibialR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="Posterior TibialL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="PeronealR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="PeronealL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="GreaterSaphenousR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="GreaterSaphenousL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
    </tr>
  </thead>
    <tbody>
      {['spontaneous', 'phasic', 'augmented', 'competent', 'nonPulsatile', 'compression'].map((condition) => (
        <tr key={condition}>
          <td className="border px-2 py-1 text-center">{condition.charAt(0).toUpperCase() + condition.slice(1)}</td>
          {['commonFemoral', 'superficialFemoral', 'popliteal', 'posteriorTibial', 'peroneal', 'greaterSaphenous'].map((region) => (
            <>
              <td className="border px-2 py-1 text-center">
                <input
                  type="checkbox"
                  name={`${region}-${condition}-R`}
                  checked={formData.conditions[region][condition]?.R}
                  onChange={(e) => handleChange(e, 'conditions', `${region}.${condition}.R`, e.target.checked)}
                />
              </td>
              <td className="border px-2 py-1 text-center">
                <input
                  type="checkbox"
                  name={`${region}-${condition}-L`}
                  checked={formData.conditions[region][condition]?.L}
                  onChange={(e) => handleChange(e, 'conditions', `${region}.${condition}.L`, e.target.checked)}
                />
              </td>
            </>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
</div>

      {/* Technician Comments */}
<div className="py-8">
  <h2 className="text-xl font-semibold">
    {allowedUsers.includes(userConfig?.username) ? (
      <div>IMPRESSIONS</div>
    ) : (
      <div>TECHNICIAN COMMENTS</div>
    )}  
  </h2>
  <div className="grid gap-6 mb-8">
    <div className="space-y-4">
{technicianComments.map((comment, index) => (
  <div key={comment.id}>
    {/* Check if this comment has a dropdown */}
    {comment.options && comment.options.length > 0 ? (
      <div className="grid gap-2 py-1">
        <div>
          {/* Dropdown for technician comments */}
          <select
            className="w-full border rounded px-3 py-2 mt-1"
            value={formData.technicianComments[index]?.value || ''}  // Ensure the value is selected from the state
            onChange={(e) => handleChange(e, 'technicianComments', index)}  // Pass index to handleChange
          >
            <option value="" disabled>Select an option</option>
            {comment.options.map((option, optionIndex) => (
              <option key={optionIndex} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    ) : (
      // Textarea for non-dropdown comments
      <div>
        <label className="block text-sm font-medium text-gray-700">
          {comment.label}
        </label>
        <textarea
          placeholder="Enter Comments here..."
          name="technicianComments"
          rows={3}
          className="w-full border rounded px-2 py-1 mt-1"
          value={formData.technicianComments[index]?.value || ''}  // Use the value from the state
          onChange={(e) => handleChange(e, 'technicianComments', index)}  // Pass index to handleChange
        />
      </div>
    )}
  </div>
))}
    </div>
  </div>
</div>


      {/* Action Buttons */}
      <div className="flex justify-between items-center mt-4">
        <div>

        {allowedUsers.includes(userConfig?.username) ? (
          <div className="flex flex-col items-start p-4 bg-white shadow-md rounded-lg border border-gray-200 w-80">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                name="signoff"
                checked={formData.signoff || false}
                onChange={(e) => handleChange(e, null, "signoff")}
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span className="ml-3 font-semibold text-gray-700 text-lg">Sign Off</span>
            </label>

            {formData.signoff && (
              <>
              <div className="mt-3 flex items-center space-x-3">
                <img
                  src={DrMadhuSign}
                  alt="Signed Off"
                  className="h-20 rounded-lg shadow-md animate-fadeIn"
                />
                <span className="text-green-600 font-medium">Successfully Signed!</span>
              </div>
              <div className="py-2 font-semibold">Dr. Madhu Pamganamamula MD FACP FASPC DABOM DABCL CCD</div>
              </>
            )}
          </div>
        ) : (
          <div className=""></div>
        )}

        {/* <button className="text-blue-500 text-sm hover:text-blue-700">
          [ PRINT PREVIEW ]
        </button> */}
        </div>
        <div>
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600"
          >
            Save Report
          </button>
          {/* <button
            onClick={handleUpdate}
            className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600 ml-4"
          >
            Update Report
          </button> */}
          <button
            onClick={handleClear}
            className="bg-gray-500 text-white px-6 py-2 rounded-md hover:bg-gray-600 ml-4"
          >
            Clear Data
          </button>
        </div>
      </div>
    </div>
    </div>

   <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />
    </div>
  );
};

export default VenousModal;